export type AuthType = "EXPLICIT";

export type EnvConfig = {
  ApiUrl: string;
  AuthType: string;
  AppVersion: string;
  MsalClientId?: string;
  MsalTenantId?: string;
  MsalApiScope?: string;
  Environment: string | "Local";
  IsProdEnvironment: boolean;
  OctopusCloudDomain: string;
  OctopusCloudPortalDomain: string;
  ZuoraDomain: string;
  UseDevMsw: boolean;
};

export const envConfig: EnvConfig = {
  ApiUrl: process.env.API_URL || "NO_API_URL_DEFINED",
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  AuthType: process.env.AUTH_TYPE as AuthType,
  AppVersion: process.env.APP_VERSION || "0.0.0-local-dev",
  MsalClientId: process.env.MSAL_CLIENT_ID,
  MsalTenantId: process.env.MSAL_TENANT_ID,
  MsalApiScope: process.env.MSAL_API_SCOPE,
  Environment: process.env.ENVIRONMENT || "Local",
  OctopusCloudDomain: process.env.OCTOPUS_CLOUD_DOMAIN || "NO_CLOUD_DOMAIN_DEFINED",
  OctopusCloudPortalDomain: process.env.OCTOPUS_CLOUD_PORTAL_DOMAIN || "NO_CLOUD_PORTAL_DOMAIN_DEFINED",
  IsProdEnvironment: process.env.ENVIRONMENT?.localeCompare("Production") === 0,
  ZuoraDomain: process.env.ZUORA_DOMAIN || "NO_ZUORA_DOMAIN",
  UseDevMsw: process.env.USE_DEV_MSW === "true",
};
